// extracted by mini-css-extract-plugin
export default {"plansContainer":"PlanCardsList_plansContainer__A3aKR","noPlans":"PlanCardsList_noPlans__Qasdg"};